export const CONTACTS = {
    phoneDisplay: "+39 347 127 0058",
    phoneHref: "tel:+393471270058",
    whatsapp: "https://wa.me/393471270058",
    email: "info@caprigianluca.it",
    linkedin: "https://www.linkedin.com/in/gianluca-capri-0623b3391",
    address: "Via S. Pertini, 5 — 60020 Sirolo (AN)",
    piva: "03026610422",
    website: "www.caprigianluca.it",
    websiteHref: "https://www.caprigianluca.it",
};

export const ESIGENZE = [
    "Progetto ERP",
    "Progetto MES",
    "Progetto IT in difficoltà",
    "Coordinamento fornitori",
    "IT Management temporaneo",
    "Assessment / verifica situazione IT",
    "Altro",
];
